import { FORTA_BLACK } from '../../utils/colors';

import type { IconProps } from './types';

const ChevronDownIcon = ({ color = FORTA_BLACK, width = 16.1667, height = 9.08333 }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16.1667 9.08333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1667 1L8.08333 8.08333L1 1"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronDownIcon;
